<app-menu class="menuApp" xmlns="http://www.w3.org/1999/html"></app-menu>
<div class="main">
  <div style="width: 90%; height: 100%; margin: auto; padding-top: 2vh">

    <!--
    <div (click)="toLocations()" class="row location">

      <div class="col-3 text-right">
        <span class="material-icons-outlined customRowIcon textXXM">place</span>
      </div>

      <div class="col-9">
        <h3 class="centerVert text-center textM">{{this.proyectoService.getProyectoActual().nombre}}</h3>
      </div>

    </div>
    -->

    <!-- HEALTH & SAFETY SECTION
    <div (click)="selectIndicator(0)" class="row deviceSection">
      <div class="deviceHeader">
        <h1 class="centerVert textXXM">{{this.localiser.get("indicators.health")}}</h1>
      </div>
    </div>
    -->

    <!-- ENERGY EFFICENCY SECTION
    <div (click)="selectIndicator(1)" class="row deviceSection">
      <div class="deviceHeader">
        <h3 class="centerVert textXXM">{{this.localiser.get("indicators.energy")}}</h3>
      </div>
    </div>
    -->

    <!-- LUMINAIRES DALI DATA SECTION
    <div (click)="selectIndicator(2)" class="row deviceSection">
      <div class="deviceHeader">
        <h3 class="centerVert textXXM">{{this.localiser.get("indicators.daliData")}}</h3>
      </div>
    </div>
    -->

    <!-- EMISSIONS SECTION
    <div (click)="selectIndicator(3)" class="row deviceSection">
      <div class="deviceHeader">
        <h3 class="centerVert textXXM">{{this.localiser.get("indicators.emissions")}}</h3>
      </div>
    </div>
    -->

    <!-- PRESENCES -->
    <div (click)="toIndicatorPresences()" class="row deviceSection">
      <div class="deviceHeader">
        <h3 class="centerVert textXXM">{{this.localiser.get("indicators.presences")}}</h3>
      </div>
    </div>

    <!-- SENSORS 4-20mA -->
    <div (click)="toIndicatorSensors()" class="row deviceSection">
      <div class="deviceHeader">
        <h3 class="centerVert textXXM">{{this.localiser.get("indicators.sensors")}}</h3>
      </div>
    </div>

  </div>
</div>
